/**
 * Spaces constants
 */

// Tab identifiers
export type SpaceTabType = 'conversations' | 'reports'

export const SPACE_TABS = {
  CONVERSATIONS: 'conversations' as SpaceTabType,
  REPORTS: 'reports' as SpaceTabType,
}

// UI related constants
export const UI = {
  MINIMUM_SEARCH_LENGTH: 2,
  SEARCH_PLACEHOLDER: 'Search for Conversations, Reports',
  EMPTY_MESSAGES: {
    CONVERSATIONS: 'No conversations found.',
    REPORTS: 'No reports found.',
  },
  NO_MORE_MESSAGES: {
    CONVERSATIONS: '',
    REPORTS: '',
  },
  TAB_LABELS: {
    CONVERSATIONS: 'Conversations',
    REPORTS: 'Reports',
  },
}

// API related constants
export const API = {
  PAGINATION: {
    DEFAULT_PAGE: 1,
    OBSERVER_THRESHOLD: 0.1,
  },
  ENDPOINTS: {
    CONVERSATIONS: '/conversations',
    REPORTS: '/reports',
  },
}

// Error messages related to spaces
export const ERROR_MESSAGES = {
  DELETE_CONVERSATION: 'Failed to delete the conversation. Please try again.',
  DELETE_REPORT: 'Failed to delete the report. Please try again.',
  GENERIC: 'Something went wrong. Please try again later.',
}
